<template>
  <div class="container mx-auto text-center sm:text-center">
    <div class="mt-5">
      <div class="w-80 container mx-auto rounded-3xl bg-transparent border border-black text-black text-base font-normal align-middle" v-if="city.name != ''">
        <div class="grid grid-cols-4">
          <div class="grid col-span-4 justify-center">
            <img :src="city.img" alt="city img" class="w-52 h-52">
          </div>
          <div class="grid row-span-2 col-span-2 text-5xl font-bold">
            <p class="pt-5 pb-5" v-text="city.temp"></p>
          </div>
          <div class="grid col-span-2 text-lg content-end">
            <p class="text-center" v-text="city.description"></p>
          </div>
          <div class="grid text-center">
            <p class="text-base" v-text="city.name"></p>
          </div>
          <div class="grid text-center">
            <p class="text-md font-bold" v-text="city.country"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default { 
    name: "Tarjeta",
    props: ['city'],
  };
</script>